import React, {ReactNode} from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/src/themes'

const Dot = styled.div`
  display: inline;
  &:before {
    content: '·';
    padding: 0 ${cssTheme.layout.spacing.s200};
  }
`

export const DotSeparatedList = ({
  listItems
}: {
  listItems: (string | ReactNode)[]
}) => {
  return (
    <>
      {listItems.map((item, index) => (
        <React.Fragment key={index}>
          {!!index && <Dot />}
          {item}
        </React.Fragment>
      ))}
    </>
  )
}
